import { defineField, defineType } from 'sanity'
import { richTextContent } from '../../data/richText'
import extractTextFromRichText from '../../utils/extractFromRichText'

export default defineType({
  name: 'featuredContent',
  title: 'Featured Content with Round Image',
  type: 'object',
  fields: [
    defineField({
      name: 'heading',
      title: 'Heading',
      type: 'string',
    }),
    defineField({
      name: 'image',
      title: 'Image',
      type: 'image',
      options: {
        hotspot: true,
      },
      validation: (rule) => rule.required(),
    }),
    defineField({
      name: 'imagePosition',
      title: 'Image Position',
      type: 'string',
      options: {
        list: [
          { title: 'Left', value: 'left' },
          { title: 'Right', value: 'right' },
        ],
        layout: 'radio',
        direction: 'horizontal',
      },
      initialValue: 'left',
    }),
    defineField({
      name: 'content',
      title: 'Content',
      type: 'array',
      of: richTextContent,
      validation: (rule) => rule.required(),
    }),
  ],
  preview: {
    select: {
      heading: 'heading',
      content: 'content',
      media: 'image',
    },
    prepare({ heading, content, media }) {
      const title = heading ? heading : extractTextFromRichText(content) || 'Featured Content'

      return {
        title,
        subtitle: 'Featured Content with Round Image',
        media,
      }
    },
  },
})